import { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import { Col, Container, Row } from 'react-bootstrap';
import ProjectCard from './components/ProjectCard';
import { uuidv7 as uuid } from 'uuidv7';
function App() {

  const [projects, setProjects] = useState(JSON.parse(localStorage.getItem('projects')) || []);

  useEffect(() => {
    localStorage.setItem('projects', JSON.stringify(projects));
  },[projects]);

  const handleStartTimer = (projectId) => {
    const now = Date.now();
    setProjects(projects.map(project => project.id === projectId ? {...project, runningSince: now} : project));
  }

  const handleStopTimer = (projectId) => { 
    const now = Date.now();
    setProjects(projects.map(project => {
      if(project.id === projectId) {
        const lastElapsed = now - project.runningSince;
        return {
          ...project,
          runningSince: null,
          elapsed: project.elapsed + lastElapsed
        }
      }
      return project;
    }));
  }

  const handleAddProject = (project) => { 
    const newProject = {
      ...project,
      runningSince: null,
      elapsed: 0,
      id: uuid()
    };
    setProjects([...projects, newProject]);
  }

  const handleDelete = (projectId) => setProjects(projects.filter(project => project.id !== projectId));

  const handleUpdateProject = (updatedProject) => {
    setProjects(projects.map(project => project.id === updatedProject.id ? updatedProject : project));
  }

  return (
    <>
      <Header onAddProject={handleAddProject}/>
      <Container className="mt-3">
        <Row>
          {
            projects.map(project => (
              <Col md={3} key={project.id}>
                <ProjectCard 
                  project={project} 
                  onUpdateProject ={handleUpdateProject}
                  onStartTimer={handleStartTimer} 
                  onStopTimer={handleStopTimer} 
                  onDelete={handleDelete}
                />
              </Col>
            ))
          }
        </Row>
      </Container>
    </>
  );
}

export default App;